/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import PRFeelingEvasFormComponent from "parog-web/components/abstract/feeling-edition-form";
import PrFeelingEvaPatientDeclaredJournalEvent from "parog-web/models/pr-feeling-eva-patient-declared-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class PRFeelingEvasPatientFormComponent extends PRFeelingEvasFormComponent {
  static forcDisplayName = "Mesure de l'activité de la PR selon le patient";
  static fullComponentId = "das28/patient-feeling-edition-form";

  @service declare session: SemeiaSessionService;

  static journalEventClass = PrFeelingEvaPatientDeclaredJournalEvent;
}
